import { createContext, Dispatch, SetStateAction } from "react";

const menuIsActiveValue: boolean = true;
const setMenuIsActiveValue: Dispatch<SetStateAction<boolean>> = () => {};

export default createContext({
 menuIsActive: menuIsActiveValue,
 setMenuIsActive: setMenuIsActiveValue,
});
